import React from 'react';

export default function NotFound() {
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'60vh', textAlign:'center' }}>
      <div style={{ fontFamily:'var(--font-display)', fontSize:96, fontWeight:700, color:'rgba(167,244,50,0.15)', lineHeight:1, marginBottom:16 }}>404</div>
      <h2 style={{ fontFamily:'var(--font-display)', fontSize:24, fontWeight:500, color:'var(--text-primary)', marginBottom:8 }}>Page not found</h2>
      <p style={{ fontSize:14, color:'var(--text-muted)', maxWidth:300 }}>The page you're looking for doesn't exist or has been moved.</p>
    </div>
  );
}
